export default "__VITE_ASSET__fc54d942__"